import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "tabs-container d-flex flex-row fl-start fl-a-e"
};
var _hoisted_2 = {
  class: "inner-tab"
};
var _hoisted_3 = {
  class: "tab-name-wrapper"
};
var _hoisted_4 = {
  class: "tab-name"
};
var _hoisted_5 = {
  key: 0,
  class: "dropdown-menu"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = ["onClick", "onDragstart", "onDrop"];
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "tab-name-wrapper"
};
var _hoisted_10 = {
  class: "tab-name",
  "data-cy": "booking-tab"
};

var _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "+", -1);

var _hoisted_12 = [_hoisted_11];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.bookings.length > _ctx.maxBookingTabsToShow ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tab more-tabs",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.toggleDropDownMenu && _ctx.toggleDropDownMenu.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, [_createElementVNode("span", _hoisted_4, "+" + _toDisplayString(_ctx.bookings.length - _ctx.maxBookingTabsToShow) + " " + _toDisplayString(_ctx.$t("tabs.more-orders")), 1)])]), _createVNode(_component_SvgIcon, {
    iconContent: _ctx.currentChevron,
    iconStyle: "width: 16px; height: 20px;"
  }, null, 8, ["iconContent"]), _createVNode(_Transition, {
    name: "dropdown"
  }, {
    default: _withCtx(function () {
      return [_ctx.isDropdownVisible ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookingHiddenTabs, function (booking, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onClick: function onClick($event) {
            return _ctx.selectBooking(booking.uuid, {
              fromMoreOrders: true
            });
          }
        }, _toDisplayString(_ctx.getTabName(booking.uuid)), 9, _hoisted_6);
      }), 128))])])) : _createCommentVNode("", true)];
    }),
    _: 1
  })])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookingVisibleTabs, function (booking, index) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tab", _ctx.getTabClass(booking.uuid)]),
      key: index,
      onClick: function onClick($event) {
        return _ctx.selectBooking(booking.uuid);
      },
      draggable: true,
      onDragstart: function onDragstart($event) {
        return _ctx.onDragStart(index);
      },
      onDragover: _cache[2] || (_cache[2] = _withModifiers(function () {}, ["prevent"])),
      onDrop: function onDrop($event) {
        return _ctx.onDrop(index);
      }
    }, [_createElementVNode("div", {
      class: "inner-tab",
      onClick: function onClick($event) {
        return _ctx.showTabNameModal(booking.uuid);
      }
    }, [booking.uuid === _ctx.selectedBookingUUID ? (_openBlock(), _createBlock(_component_SvgIcon, {
      key: 0,
      iconContent: _ctx.editPen,
      iconStyle: "width: 20px; height: 20px;"
    }, null, 8, ["iconContent"])) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getTabName(booking.uuid)), 1)])], 8, _hoisted_8), booking.uuid === _ctx.selectedBookingUUID ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "close-button",
      onClick: _cache[1] || (_cache[1] = function ($event) {
        return _ctx.closeTab();
      }),
      "data-cy": "close-booking-tab-button"
    })) : _createCommentVNode("", true)], 42, _hoisted_7);
  }), 128)), _ctx.hasSalesStarted ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "new-tab",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.createNewBooking();
    }),
    "data-cy": "add-booking-button"
  }, _hoisted_12)) : _createCommentVNode("", true)]);
}